import { render, staticRenderFns } from "./PurchaseExpired.vue?vue&type=template&id=c7a079c4&"
import script from "./PurchaseExpired.vue?vue&type=script&lang=js&"
export * from "./PurchaseExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports